import { Refresh } from '@mui/icons-material';
import { ListPageHeaderProps } from '../../../ui/components/pure/page-headers/list/list-page-header.component';

export function makeDashboardHeaderProps(projectName?: string, onRefresh?: () => void): ListPageHeaderProps<{}> {
  return {
    title: 'Dashboard',
    subtitle: projectName ? `What's been happening at ${projectName}` : '',
    controls: onRefresh
      ? {
          form: {},
          onFormInput: () => undefined,
          inputs: [],
          singleAction: {
            label: 'Refresh',
            Icon: Refresh,
            onClick: onRefresh
          }
        }
      : undefined
  };
}
